import { render } from "./presupuesto.vue?vue&type=template&id=7511f0ba"
import script from "./presupuesto.vue?vue&type=script&lang=js"
export * from "./presupuesto.vue?vue&type=script&lang=js"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__